"use client";

import { RadioScopedContextProvider, useRadioProviderContext } from "../__chunks/UVUMR3WP.js";
import { useComposite } from "../__chunks/ITI7HKP4.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import { useWrapElement } from "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/radio/radio-group.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useRadioGroup = createHook(function useRadioGroup2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useRadioProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component.");
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(RadioScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  props = __spreadValues({
    role: "radiogroup"
  }, props);
  props = useComposite(__spreadValues({
    store: store
  }, props));
  return props;
});
var RadioGroup = forwardRef(function RadioGroup2(props) {
  var htmlProps = useRadioGroup(props);
  return createElement(TagName, htmlProps);
});
export { RadioGroup, useRadioGroup };